$(document).ready(function(){
	
	$('ul.topMenu li a').click(function(event) {
		event.preventDefault();
		var ids = $(this).attr('href');
		 $('html, body').animate({
			scrollTop: $(ids).offset().top - 50
		}, 2000);
	});

	
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#select_pkg").offset().top - 20
		}, 2000);
	});
	
	//accordion JS 
	$(".accordion").click(function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn_content');
		var idx = $('.acdn_content').index(answerDiv);
		
		$('.acdn_content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.accordion').removeClass('accordion_open');
				});
			}
        });
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion_open');
			});
		} else {
		  questionDiv.addClass('accordion_open');
		  answerDiv.stop().slideDown(500);
		}
	});
	
	
	//Package accordion JS 
	
	$('.package-accordion').click(function(e) {
		$(this).closest('.pakge_strip').find('.package-acdn-content').slideToggle();
		$(this).closest('.pakge_strip').find('.package-accordion').toggleClass('package-accordion-open');
	});
	
	
		var numSlick = 0;
		$('.slide-div').each( function() {
		  numSlick++;
		  $(this).addClass( 'slider-' + numSlick ).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: false,
			asNavFor: '.slider-nav.slider-' + numSlick
		  });
		});
	
		numSlick = 0;
		$('.slider-nav').each( function() {
		  numSlick++;
		  $(this).addClass( 'slider-' + numSlick ).slick({
			vertical: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			asNavFor: '.slide-div.slider-' + numSlick,
			arrow: false,
			focusOnSelect: true,
		});
	});
	
	$('.section2-slider-row').slick({
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,			
		speed: 300,
		arrows: true,
		dots: true,
		responsive: [
		{
			breakpoint: 767,
			settings: {
				slidesToShow:1,
				slidesToScroll: 1,
			}
		},
		]
	});
	
	$('.s5_slider_row').slick({
		dots: true,
		slidesToShow:3,
		slidesToScroll: 1,
		adaptiveHeight: false,
		variableWidth: true,
		centerMode: false,
		arrows:false,
		responsive: [
		{
			breakpoint: 1023,
			settings: {
			slidesToShow:2,
			slidesToScroll: 1,
			centerMode: true,
		  }
		},
			
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow:1,
			slidesToScroll: 1,
			centerMode: true,
			variableWidth: true,
			arrows:true,
		  }
		},
		] 
	});	
	
	//TAB
	
	$('.section9-tab-coloumn').click(function(e) {
		$('.section9-tab-coloumn').removeClass('active');
		$(this).addClass('active');	tff
	});
	
	$('#tab_col_1').click(function(e) {
        $('#tab_cont_1').show();
		$('#tab_cont_2, #tab_cont_3').hide();
    });
	
	$('#tab_col_2').click(function(e) {
        $('#tab_cont_2').show();
		$('#tab_cont_1, #tab_cont_3').hide();
    });
	
	$('#tab_col_3').click(function(e) {
        $('#tab_cont_3').show();
		$('#tab_cont_1, #tab_cont_2').hide();
    });
	

	//SELECT COLOR
	$('.color-tog').click(function(e) {
		$('.color-drower').slideUp();
		if ( $(this).next('.color-drower').is(':visible')){
			$(this).next('.color-drower').slideUp();
		}else{
			$(this).next('.color-drower').slideDown();
		}
		
		 event.stopPropagation();
	});
	
	$(document).click(function(e) {
        $('.color-drower').slideUp();
    });
	
	
	$('.colorname-list li').click(function(e) {
		$(this).closest('.color-drower').slideUp();
		$(this).closest('.selct-colorbx').find('.color-tog').html($(this).html());
	});
	
});

$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
	if ($(this).scrollTop() > 10){
	   $('.mobilemenu').addClass('mobimenu-top');
	}else{
	   $('.mobilemenu').removeClass('mobimenu-top');
	}
	
});

//MODAL Shades
function openModal() {
  document.getElementById('shadeModal').style.display = 'block';
}

function closeModal() {
  document.getElementById('shadeModal').style.display = 'none';
}

// Optional: Close the modal if the user clicks outside of it
window.onclick = function(event) {
  let modal = document.getElementById('shadeModal');
  if (event.target == modal) {
    closeModal();
  }
}
